import React from 'react';
import { styled } from '@mui/material/styles';
import { ListItemButton, ListItemText } from '@mui/material';
import { Link } from 'react-router-dom';

const StyCategoryListItem = styled(ListItemButton, {
    name: 'StyCategoryListItem',
    shouldForwardProp: (prop) => prop !== 'isSelected',
})<{ isSelected: boolean }>(({ isSelected, theme }) => ({
    paddingRight: '1.5rem',
    paddingLeft: '1.5rem',
    ...(isSelected
        ? {
              color: theme.palette.primary.main,
              backgroundColor: theme.palette.primary.background,
              '&:hover': {
                  backgroundColor: theme.palette.primary.background,
              },
          }
        : {}),
}));

export type CategoryItemT = {
    label: string;
    value: string;
    disabled?: boolean;
    removable?: boolean;
};

type Props = {
    item: CategoryItemT;
    isSelected: boolean;
};

const CategoryItem = ({ item, isSelected }: Props): React.ReactElement => (
    <Link
        style={{ color: 'inherit', textDecoration: 'none' }}
        to={`/cellar/${item.value}`}
    >
        <StyCategoryListItem isSelected={isSelected} data-value={item.value}>
            <ListItemText primary={item.label} />
        </StyCategoryListItem>
    </Link>
);

export default React.memo(CategoryItem);
